export type RosCatalogKind = 'app' | 'tool' | 'public_app'

export interface RosCatalogEntry {
  id: string
  kind: RosCatalogKind
  parentAppId: string | null
  parentName?: string
  name: string
  description: string
  url: string
  category: string | null
  icon: string | null
}

export async function listRosCatalog(
  apiBaseUrl: string,
  fetcher: (input: string, init?: RequestInit) => Promise<Response>,
): Promise<RosCatalogEntry[]> {
  const response = await fetcher(`${apiBaseUrl}/api/r3/registry-catalog`, {cache: 'no-store'})
  if (!response.ok) throw new Error(`catalog list ${response.status}`)
  const body = await response.json() as {entries?: RosCatalogEntry[]}
  return Array.isArray(body.entries) ? body.entries : []
}
